import React, { useContext, useEffect, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  IconButton,
  makeStyles,
  Typography,
  useTheme,
} from '@material-ui/core';
import { ProfileContext } from '../../../services/profile/profile.context';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  name: {
    fontWeight: 900,
  },
  userInfo: {
    display: 'block',
  },
  avatar: {
    width: 35,
    height: 35,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(768)]: {
      display: 'none',
    },
  },
  navItem: {
    margin: '0 6px',
  },
  button: {
    color: '#fff',
  },
  icon: {
    color: '#fff',
  },
  settingMenuMobile: {
    [theme.breakpoints.up(768)]: {
      display: 'none',
    },
    color: '#fff',
  },
  menu: {
    transform: 'translateX(23%) translateY(0px)',
    width: '270px',
  },
  mobileItem: {
    [theme.breakpoints.up(768)]: {
      display: 'none',
    },
  },
}));

const default_profile = '/icons/default_profile.png';

export const SettingMenu = () => {
  const classes = useStyles();
  const { setUserData, setUserPreferTime } = useContext(AuthenticationContext);
  const { user, setUser, profileImage, setProfileImage } =
    useContext(ProfileContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [x, setX] = useState('23%');
  const [y, setY] = useState('0px');

  const open = Boolean(anchorEl);
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(768));

  useEffect(() => {
    if (matches) {
      setX('4%');
      setY('9px');
    } else {
      setX('23%');
      setY('0px');
    }

    return false;
  }, [matches]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(!openMenu);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(!openMenu);
  };

  const logout = () => {
    setUser(null);
    setUserData(null);
    setUserPreferTime(null);
    setProfileImage({
      default: default_profile,
      value: '',
      error: '',
      blob: '',
    });
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      Cookies.remove(cookieName);
    });
    localStorage.clear();
    console.clear();
    history.push('/');
  };

  return (
    <Box>
      <Box className={classes.nav}>
        <Box className={classes.navItem}>
          <Button
            onClick={() => history.push('/meetings')}
            variant='text'
            className={classes.button}
            id='nav-home'
          >
            Home
          </Button>

          <Button
            onClick={() => history.push('/explore')}
            variant='text'
            className={classes.button}
            id='nav-home'
          >
            Explore
          </Button>
        </Box>

        <Box className={classes.navItem}>
          <IconButton
            aria-label='notifications'
            onClick={() => history.push('/coming-soon')}
          >
            <Badge>
              <NotificationsNoneOutlinedIcon className={classes.icon} />
            </Badge>
          </IconButton>
        </Box>

        <Box className={classes.navItem}>
          <Button
            variant='text'
            onClick={handleClick}
            id='menu-button'
            className={classes.button}
            startIcon={
              <Avatar src={profileImage.default} className={classes.avatar} />
            }
            endIcon={
              openMenu ? (
                <KeyboardArrowUpIcon className={classes.icon} />
              ) : (
                <KeyboardArrowDownIcon className={classes.icon} />
              )
            }
          >
            Account
          </Button>
        </Box>
      </Box>

      <IconButton
        aria-label='setting'
        className={classes.settingMenuMobile}
        size='small'
        onClick={handleClick}
      >
        <MenuRoundedIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            transform: `translateX(${x}) translateY(${y})`,
            width: 270,
          },
        }}
      >
        <MenuItem className={classes.userInfo}>
          <Typography className={classes.name}>
            {user && user.first_name} {user && user.last_name}
          </Typography>
          <Typography className={classes.email}>
            {user && user.email}
          </Typography>
        </MenuItem>

        <Divider light />

        <MenuItem onClick={() => history.push('/account/profile')}>
          Edit Profile
        </MenuItem>
        <MenuItem onClick={() => history.push('/account/change-password')}>
          Account Settings
        </MenuItem>
        <MenuItem
          onClick={() => history.push('/explore')}
          className={classes.mobileItem}
        >
          Explore
        </MenuItem>
        <MenuItem
          onClick={() => history.push('/coming-soon')}
          className={classes.mobileItem}
        >
          Notifications
        </MenuItem>

        <Divider light />
        <MenuItem onClick={logout} id='sign-out'>
          Sign out
        </MenuItem>
      </Menu>
    </Box>
  );
};
